import { usePostHogWalletIdentify } from 'utils/usePostHogIdentify'

export function WalletPostHogIdentify() {
  usePostHogWalletIdentify()
  return null
}
